import { useTranslation } from "react-i18next";
import type { NeedValueDto } from "../../autogen/bff-api";
import { useRunsPublicProcurements } from "../../common/organization/useRunsPublicProcurements";

export const useNeedValueLabel = (): string => {
  const { t } = useTranslation();
  return useRunsPublicProcurements() ? t("Estimated value") : t("Budget");
};

const nokFormatter = new Intl.NumberFormat("nb-NO");

export const useNeedValueText = (): ((value: NeedValueDto | null | undefined) => string) => {
  const { t } = useTranslation();
  return (value) => {
    if (value?.unknown) return t("Don't know");
    return value?.value == null ? "–" : `${nokFormatter.format(value.value)} NOK`;
  };
};
